"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeAriaHiddenOnSiblings = void 0;
var changeAriaHiddenOnSiblings = function changeAriaHiddenOnSiblings(wrapper, state) {
  if (!wrapper) return;
  var parent = wrapper.parentElement;
  if (!parent) return;
  Array.from(parent.children).filter(function (el) {
    return el.tagName !== 'SCRIPT' && el !== wrapper;
  }).forEach(function (el) {
    if (state && !el.attributes['aria-hidden']) {
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('data-stencil-aria-hidden-added', 'true');
    } else if (!state && el.hasAttribute('data-stencil-aria-hidden-added')) {
      el.removeAttribute('aria-hidden');
      el.removeAttribute('data-stencil-aria-hidden-added');
    }
  });
};
exports.changeAriaHiddenOnSiblings = changeAriaHiddenOnSiblings;